import React, { useContext } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Context as ConfigContext } from '../Config';
import WithTitle from '../toolkit/WithTitle';
import useArticlePageData from '../hooks/useArticlePageData';
import useTranslation from '../hooks/useTranslation';
import usePageClassName from '../hooks/usePageClassName';
import { ArticleContext, RelatedArticlesContext } from '../contexts';
// import ArticleSchema from '../toolkit/ArticleSchema';
import ErrorPage from './error';
import Error404Page from './error404';
import Error401Page from './error401';

type Props = RouteComponentProps<{
  articleId: string;
}>;

const ArticlePage: React.FC<Props> = ({ match }) => {
  const { t } = useTranslation();
  usePageClassName('article-page');

  const { articleId } = match.params;
  const articleMatch = articleId.match(/^\d+/);
  let _articleId = articleMatch ? articleMatch[0] : '';
  const { data, fetchingStatus } = useArticlePageData(_articleId);
  const { pages, pageLoadingIndicator: Loader } = useContext(ConfigContext);

  if (fetchingStatus === 'is-fetching' || fetchingStatus === 'not-started')
    return <Loader />;
  if (fetchingStatus === 'NotFound') return <Error404Page />;
  if (fetchingStatus === 'LoginRequired') return <Error401Page />;
  if (fetchingStatus !== 'has-fetched' || !data || !data.article)
    return <ErrorPage />;

  const article = data.article;
  const relatedArticles = data.relatedArticles?.results.map((r) => ({
    ...r,
    categoryId: r.category.id,
  }));

  const Page = pages.article.component;
  const title = t('pageTitles.article', '{{article.title}}', { article });

  return (
    <ArticleContext.Provider value={article}>
      <RelatedArticlesContext.Provider value={relatedArticles}>
        <>
          {/* <ArticleSchema key={articleId} /> */}

          <WithTitle title={title}>
            <Page />
          </WithTitle>
        </>
      </RelatedArticlesContext.Provider>
    </ArticleContext.Provider>
  );
};
ArticlePage.displayName = 'ArticlePage';

export default ArticlePage;
